import type { TourDefinition } from '../types';

export const emailTour: TourDefinition = {
  id: 'email',
  title: 'Email',
  steps: [
    {
      element: '[data-tour="email-account-dropdown"]',
      popover: {
        title: 'Conta de Email',
        description:
          'Selecione a conta de email que deseja visualizar.',
        side: 'bottom',
        align: 'start',
      },
    },
    {
      element: '[data-tour="email-folder-dropdown"]',
      popover: {
        title: 'Pastas',
        description:
          'Navegue entre Caixa de Entrada, Enviados, Rascunhos e outras pastas.',
        side: 'bottom',
        align: 'start',
      },
    },
    {
      element: '[data-tour="email-list"]',
      popover: {
        title: 'Lista de Emails',
        description:
          'Visualize seus emails. Clique em qualquer mensagem para ler o conteúdo completo.',
        side: 'right',
        align: 'center',
      },
    },
    {
      element: '[data-tour="email-compose-btn"]',
      popover: {
        title: 'Novo Email',
        description:
          'Clique aqui para compor um novo email diretamente do CRM.',
        side: 'bottom',
        align: 'center',
      },
    },
    {
      element: '[data-tour="email-viewer"]',
      popover: {
        title: 'Visualizador',
        description:
          'Leia e responda emails sem sair da plataforma.',
        side: 'left',
        align: 'center',
      },
    },
  ],
};
